const ACTION_MAP = {
  elaborateNotePrompt: "elaborate",
  rewriteNotePrompt: "rewrite",
  polishNotePrompt: "polish",
  behavior: "behavior",
  response: "response",
  plan: "plan",
};

export const normalizeAction = (key) => ACTION_MAP[key] ?? key;

export const trackAiSuggestionShown = (props) => {
  try {
    window.pendo?.track?.("ai_suggestion_shown", { ...props, timestamp: new Date().toISOString() });
  } catch {
    // never block the user
  }
};

export const trackAiSuggestionResolved = (props) => {
  try {
    window.pendo?.track?.("ai_suggestion_resolved", { ...props, timestamp: new Date().toISOString() });
  } catch {
    // never block the user
  }
};

export const trackAiNoteFinalized = (props) => {
  try {
    window.pendo?.track?.("ai_note_finalized", { ...props, timestamp: new Date().toISOString() });
  } catch {
    // never block the user
  }
};
